<template>
    <div>
        <b-card
            class="mt-3"
            body-class="mt-3"
            v-if="provider === 'woo'"
            >
            <h6 class="card-title">WooCommerce</h6>

            <small>URL</small>
            <b-form-input v-model="connect.url"></b-form-input>

            <small>Consumer Key(ck_...)</small>
            <b-form-input v-model="connect.ck"></b-form-input>

            <small>Consumer Secret(cs_...)</small>
            <b-form-input v-model="connect.cs"></b-form-input>

            <small>API ver</small>
            <b-form-input v-model="connect.ver"></b-form-input>

            <div class="text-right mt-3">
                <b-button class="btn-theme" @click="save">保存</b-button>
            </div>
        </b-card>

        <b-card
            class="mt-3"
            body-class="mt-3"
            v-if="provider === 'dhl'"
            >
            <h6 class="card-title">DHL</h6>

            <small>Account No</small>
            <b-form-input v-model="connect.account_no"></b-form-input>

            <small>API Key</small>
            <b-form-input v-model="connect.api_key"></b-form-input>

            <small>API Secret</small>
            <b-form-input v-model="connect.api_secret"></b-form-input>

            <div class="text-right mt-3">
                <b-button class="btn-theme" @click="save">保存</b-button>
            </div>
        </b-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import Item from '@/components/Item.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import ItemThumb from '@/components/ItemThumb.vue'
import UserSettingInfo from '@/components/UserSettingInfo.vue'

export default {
    components: {
        GridPage,
        Item,
        ItemBadges,
        ItemThumb,
        UserSettingInfo,
    },
    props: {
        provider: {
            type: String,
            required: true,
            default() {
                return null
            },
        },
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'auth_email',
            'trans',
        ])
    },
    data() {
        return {
            connect: {
            },
            error: {
            },
        }
    },
    watch: {
        $route: {
            async handler () {
            },
            immediate: true
        }
    },
    mounted() {
        this.$set(this.connect, 'provider', this.provider)

        switch (this.provider) {
            case 'woo':
                this.$set(this.connect, 'url', null)
                this.$set(this.connect, 'ck', null)
                this.$set(this.connect, 'cs', null)
                this.$set(this.connect, 'ver', null)
                break
            case 'dhl':
                this.$set(this.connect, 'account_no', null)
                this.$set(this.connect, 'api_key', null)
                this.$set(this.connect, 'api_secret', null)
                break
        }
    },
    methods: {
        async save () {
            await this.$store
                .dispatch('auth/connect', this.connect)
                .then((response) => {
                    this.$router.push({ name: 'me', })
                })
                .catch((error) => {
                })
        },
    },
}
</script>

